import React, { ComponentType, MutableRefObject, useCallback, useEffect, useRef, useState } from 'react';
import CustomContentArea from '@om-fe/core/components/custom-content/custom-content-area';
import SimpleSearchTrigger from '@om-fe/core/components/search/simple-search-trigger';
import getConfig, { BannerMatrixConfig, OMFE2ConfigModel, CustomContentAreaPosition, LeftSideBarConfig, SiteLinksConfig } from '@om-fe/core/utils/config';
import { sidebarBem } from '@om-fe/core/components/constants';
import { SearchPageComponent } from '@om-fe/core/pages/theme1/search-page';
import { EMRoutingContextInterface, RouteNames, RouteDetails, RouteModel } from '@om-fe/core/core/routing/utils';
import HelpSupportLinksCore from '@om-fe/core/pages/theme1/parts/help-support-links';
import HelpSupportLinksNDW from './help-support-links/help-support-links';
import SettingsMenu from '@om-fe/core/pages/theme1/parts/settings-menu';
import withRouting, { useEMRouting } from '@om-fe/core/core/routing/with-routing';
import { FavoriteTournamentsMenu as FavoriteTournamentsMenuNormal } from '@om-fe/widgets/dist/widgets/menus/favorite-tournaments-menu/favorite-tournaments-menu';
import { PopularLinksMenu } from '@om-fe/widgets/dist/widgets/menus/popular-links-menu/popular-links-menu';
import { SportRouteParams } from '@om-fe/widgets/dist/common/routing/routing.constants';
import { SportsMenu } from '@om-fe/widgets/dist/widgets/menus/sports-menu/sports-menu';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import {
    EventNavigationMenuSelectedDetails,
} from '@om-fe/widgets/dist/widgets/sports-menu/event-navigation-menu/event-navigation-menu.types';
import { useParams, useLocation } from 'react-router';
import { ALL_LOCATION_ID } from '@om-fe/core/components/nav-secondary/location-nav/location-nav';
import { ALL_CATEGORIES_ID } from '@om-fe/core/components/nav-secondary/category-nav/category-nav';
import { ALL_CHILDREN_ID } from '@om-fe/core/components/nav-secondary/parent-nav/parent-nav-constants';
import { SportsMenuType } from './match-content-tabs/match-content-tabs.constants';
import { DisciplineLiveStatus, DisciplinesType, DisciplineVirtualStatus } from '@om-fe/models';
import { getDisciplineRouteDetails } from '@om-fe/core/components/discipline-anchor/discipline-anchor.utils';
import { getDisciplineRouteType } from '@om-fe/core/components/discipline-anchor/discipline-route.utils';
import { getCurrentVirtualState, setVirtualStateExtraParams, VirtualStateModel } from '@om-fe/core/core/routing/custom-routes/custom-routes.utils';
import { scrollContainerToPosition } from '@om-fe/core/utils/dom';
import { QuickLink, QuickLinkLayout } from './quick-link/quick-link';
import { isBrowser, PlatformTypes } from '@om-fe/utils';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { SiteLinks } from '@om-fe/core/components/site-links/site-links';
import FavoriteTournamentsMenuV2 from './menu/favorite-tournament/favorite-tournament-menu';
import BannermatrixBanner from '@om-fe/core/components/external-widgets/bannermatrix-banner';

const config: OMFE2ConfigModel = getConfig();
const specialBonusSingle: boolean = config?.specialBonus?.single;
const specialBonusMulti: boolean = config?.specialBonus?.multi;
const bannerMatrixConfig: BannerMatrixConfig | undefined = config.bannerMatrix;
const leftSideBarConfig: LeftSideBarConfig | undefined = config.leftSideBar;
const siteLinks: boolean = leftSideBarConfig?.siteLinks || false;
const siteLinksConfig: SiteLinksConfig | undefined = leftSideBarConfig?.siteLinksConfig;
const helpSupportLinks: boolean = leftSideBarConfig?.helpSupportLinks || false;
const coreHelpSupportLinks: boolean = leftSideBarConfig?.coreHelpSupportLinks || false;
const settingsMenu: boolean = leftSideBarConfig?.settingsMenu || false;
const displayEarlySettlement: boolean = leftSideBarConfig?.displayEarlySettlement || false;
const enabledDisciplinePage : boolean = config?.enabledDisciplinePage ?? false;
const showPopularLinksDisciplineIcons: boolean = leftSideBarConfig?.popularLinksMenu?.showDisciplineIcons ?? true;

interface RouteParams {
    readonly disciplineId?: string;
    readonly sportLocationId?: string;
    readonly eventCategoryId?: string;
    readonly sportChildId?: string;
    readonly tournamentId?: string;
    readonly locationId?: string;
}

export type LeftSideBarProps = EMRoutingContextInterface;

interface LeftSideBarStoreProps {
    readonly deviceType?: PlatformTypes;
}

function buildSelectionDetailsFromParams(
    disciplineId?: string,
    sportLocationId?: string,
    eventCategoryId?: string,
    sportChildId?: string,
    tournamentId?: string,
    locationId?: string,
): EventNavigationMenuSelectedDetails {
    const location: string | undefined = (locationId || sportLocationId);

    return {
        sport: disciplineId,
        sportChild: sportChildId === ALL_CHILDREN_ID ? undefined : sportChildId,
        tournamentCategory: eventCategoryId === ALL_CATEGORIES_ID ? undefined : eventCategoryId,
        location: location === ALL_LOCATION_ID ? undefined : location,
        tournament: tournamentId,
    };
}

function LeftSideBarComponent({ deviceType }: LeftSideBarProps & LeftSideBarStoreProps) {
    const { gettext } = useI18NContext();
    const { getFullPath } = useEMRouting();
    const {
        disciplineId,
        sportChildId,
        eventCategoryId,
        sportLocationId,
        locationId,
        tournamentId,
    } = useParams<RouteParams>();

    const [selectedSportsMenuType, setSportsMenuType] = useState<SportsMenuType | undefined>(enabledDisciplinePage ? undefined : SportsMenuType.AllSports);
    const [selectedDetails, setSelectedDetails] = useState<EventNavigationMenuSelectedDetails>(
        buildSelectionDetailsFromParams(
            disciplineId,
            sportLocationId,
            eventCategoryId,
            sportChildId,
            tournamentId,
            locationId,
        ),
    );

    const routeSelectedSuppressRef: MutableRefObject<number | undefined> = useRef<number | undefined>(undefined);

    const updateSelectedPopularDetails = useCallback(() => {
        setSportsMenuType(SportsMenuType.None);
    }, []);

    const currentRoute: RouteModel | undefined = useEMRouting().getRouteByUrl(useLocation().pathname);
    const isEsportsPage: boolean = currentRoute?.isEsportsRoute ? true : false;
    const enabledHorseRacing: boolean = config.enabledHorseRacing ?? false;
    const enabledGreyHound: boolean = config.enabledGreyHound ?? false;
    const enabledBetSimulate: boolean = config.simulate?.enabled ?? false;
 
    const enabledNextRace: boolean = !!((disciplineId === DisciplinesType.HorseRacing && enabledHorseRacing) || (disciplineId === DisciplinesType.GreyHounds && enabledGreyHound))
 

    const getDistanceFromTop = useCallback((details: EventNavigationMenuSelectedDetails) => {
        if (isBrowser() && config.virtualState){
            let checkMenu: string = '';
            if (details.location) {
                checkMenu = `a[href*='/${details.sport}/'][href*='/${details.location}/']`;
            } else if (details.tournamentCategory) {
                checkMenu = `a[href*='/${details.sport}/'][href*='/${details.tournamentCategory}/']`;
            } else if (details.tournament) {
                checkMenu = `a[href$='/${details.tournament}`;
            }

            if (checkMenu) {
                const target: Element | null = document.querySelector(checkMenu);
                if (target) {
                    const rect: DOMRect = target.getBoundingClientRect();
                    setVirtualStateExtraParams({ focusMenuFromTop: rect.top });
                }
            }
        }
    }, []);

    const updateSelectedTopSportsDetails = useCallback((details: EventNavigationMenuSelectedDetails) => {
        const { sport, sportChild } = details;
        setVirtualStateExtraParams({
            selectedSportsMenuType: SportsMenuType.TopSports,
            selectedSportId: sport,
            selectedSportChild: sportChild,
        });
        setSportsMenuType(SportsMenuType.TopSports);
        clearTimeout(routeSelectedSuppressRef.current);
        routeSelectedSuppressRef.current = +setTimeout(() => {
            return routeSelectedSuppressRef.current = undefined;
        });
        setSelectedDetails(details);
        getDistanceFromTop(details);
    }, []);

    const updateSelectedLiveSportsDetails = useCallback((details: EventNavigationMenuSelectedDetails) => {
        setSportsMenuType(SportsMenuType.LiveSports);
        clearTimeout(routeSelectedSuppressRef.current);
        routeSelectedSuppressRef.current = +setTimeout(() => {
            return routeSelectedSuppressRef.current = undefined;
        });

        setSelectedDetails(details);
    }, []);

    const updateSelectedAllSportsDetails = useCallback((details: EventNavigationMenuSelectedDetails) => {
        const { sport, sportChild } = details;
        setVirtualStateExtraParams({
            selectedSportsMenuType: SportsMenuType.AllSports,
            selectedSportId: sport,
            selectedSportChild: sportChild,
        });
        setSportsMenuType(SportsMenuType.AllSports);
        clearTimeout(routeSelectedSuppressRef.current);
        routeSelectedSuppressRef.current = +setTimeout(() => {
            return routeSelectedSuppressRef.current = undefined;
        });
        setSelectedDetails(details);
        getDistanceFromTop(details);
    }, []);

    useEffect(() => {
        if (routeSelectedSuppressRef.current) {
            return;
        }

        setSelectedDetails(buildSelectionDetailsFromParams(
            disciplineId,
            sportLocationId,
            eventCategoryId,
            sportChildId,
            tournamentId,
            locationId,
        ));

        const virtualState: VirtualStateModel = getCurrentVirtualState();
        if (
            config.virtualState &&
            virtualState &&
            !virtualState.action &&
            virtualState.forwardState?.params &&
            virtualState.forwardState.params.disciplineId &&
            (virtualState.forwardState.name === RouteNames.tournament || virtualState.forwardState.name === RouteNames.tournamentLocation || virtualState.forwardState.name === RouteNames.tournamentCategories)
        ) {
            setSportsMenuType(virtualState.extraParams?.selectedSportsMenuType);

            if (virtualState.extraParams?.selectedSportChild && virtualState.extraParams.selectedSportChild === virtualState.forwardState.params.disciplineId) {
                setSelectedDetails({
                    sport: virtualState.extraParams.selectedSportId,
                    sportChild: virtualState.extraParams.selectedSportChild,
                })
            } else {
                setSelectedDetails({
                    sport: virtualState.forwardState.params.disciplineId,
                });
            }

            setTimeout(() => {
                const url: string = `${virtualState.forwardState.params.disciplineName}/${virtualState.forwardState.params.disciplineId}/${virtualState.forwardState.params.locationName || virtualState.forwardState.params.eventCategoryName}/${virtualState.forwardState.params.locationId || virtualState.forwardState.params.eventCategoryId}`;
                scrollContainerToPosition(`a[href*='${url}']`, virtualState.extraParams?.focusMenuFromTop || 'center', 'Sidebar--Left');
            }, 0);
        }
        
    }, [disciplineId, eventCategoryId, locationId, sportChildId, sportLocationId, tournamentId]);

    const generateSportsPageUrl = useCallback((params: SportRouteParams): string | undefined => {
        const routeDetails: RouteDetails = getDisciplineRouteDetails({
            childId: enabledNextRace ? '0' : params.childSportId,
            childName: enabledNextRace ? 'all' : params.childSportName,
            disciplineId: params.sportId,
            disciplineName: params.sportName,
            isLive: false,
            disciplineRouteType: getDisciplineRouteType(params),
            gettext,
        });

        return getFullPath(routeDetails.routeName, routeDetails.routeParams);
    }, [getFullPath, gettext]);

    const FavoriteTournamentsMenu = (() => {
        if (config.favoriteV2) {
            return FavoriteTournamentsMenuV2;
        }

        return FavoriteTournamentsMenuNormal;
    })();

    const virtualSportRoute = getFullPath(RouteNames.newVirtualSports);
    
    return (
        <aside className={sidebarBem({
            modifiers: {
                Left: true,
            },
        })}>
            <CustomContentArea contentRef={CustomContentAreaPosition.TOP_LEFT_1} />
            {bannerMatrixConfig?.showOnLeftAboveSearch &&
                <BannermatrixBanner
                    className="BannerWidgetLeftAboveSearch BannerWidgetColorPack"
                    positionTag="left-above-search"
                />
            }
            <SimpleSearchTrigger
                defaultSearchMap={SearchPageComponent.defaultSearchMap}
                searchPlaceholder={gettext('Search')}
                searchRouteName={RouteNames.search}
            />
            {siteLinks &&
                <SiteLinks
                    deviceType={deviceType}
                    disableNextEvents={siteLinksConfig?.disableNextEvents ?? false}
                    disablePopularEvents={siteLinksConfig?.disablePopularEvents ?? false}
                />
            }
            <FavoriteTournamentsMenu
                widgetTitle={gettext('Favorites Tournaments')}
                showDisciplineIcons={true}
                isEsportsPage={isEsportsPage ?? false}
                enabledHorseRacing={enabledHorseRacing}
                enabledGreyHound={enabledGreyHound}
            />
            {bannerMatrixConfig?.showOnLeftAbovePopular &&
                <BannermatrixBanner
                    className="BannerWidgetLeftAbovePopular BannerWidgetColorPack"
                    positionTag="left-above-popular"
                />
            }
            {(specialBonusSingle || specialBonusMulti) && (
                <QuickLink layout={QuickLinkLayout.Menu} />
            )}
            <PopularLinksMenu
                widgetTitle={gettext('Popular')}
                showDisciplineIcons={showPopularLinksDisciplineIcons}
                onRouteChange={updateSelectedPopularDetails}
                enabledHorseRacing={enabledHorseRacing}
                enabledGreyHound={enabledGreyHound}
            />
            {bannerMatrixConfig?.showOnLeftUnderPopular &&
                <BannermatrixBanner
                    className="BannerWidgetLeftUnderPopular BannerWidgetColorPack"
                    positionTag="left-under-popular"
                />
            }
            {!isEsportsPage 
                ? (
                    <SportsMenu
                        controlledSelection
                        sportRoute={enabledDisciplinePage ? generateSportsPageUrl : false}
                        virtualSportRoute={virtualSportRoute}
                        displayShortTournamentName={true}
                        widgetTitle={gettext('Top Sports')}
                        showTopSportsOnly={true}
                        hideTournament={true}
                        hideLocation={enabledDisciplinePage ? true : false}
                        selectedSport={selectedSportsMenuType === SportsMenuType.TopSports || !selectedSportsMenuType ? selectedDetails.sport : ''}
                        selectedTournamentCategory={selectedSportsMenuType === SportsMenuType.TopSports || !selectedSportsMenuType ? selectedDetails.tournamentCategory : ''}
                        selectedLocation={selectedSportsMenuType === SportsMenuType.TopSports || !selectedSportsMenuType ? selectedDetails.location : ''}
                        selectedSportChild={selectedSportsMenuType === SportsMenuType.TopSports || !selectedSportsMenuType ? selectedDetails.sportChild : ''}
                        selectedTournament={selectedSportsMenuType === SportsMenuType.TopSports || !selectedSportsMenuType ? selectedDetails.tournament : ''}
                        onSelectedDetailsChange={updateSelectedTopSportsDetails}
                        showMoreText={gettext('Show More')}
                        showLessIcon={'minus'}
                        showMoreIcon={'plus'}
                        supportTournamentNav={true}
                        enabledBetSimulate={enabledBetSimulate}
                    />
                ) : (
                    <SportsMenu
                        controlledSelection
                        sportRoute={generateSportsPageUrl}
                        virtualSportRoute={virtualSportRoute}
                        displayShortTournamentName={true}
                        widgetTitle={gettext('Live sports')}
                        selectedSport={selectedSportsMenuType === SportsMenuType.LiveSports ? selectedDetails.sport : ''}
                        selectedTournamentCategory={selectedSportsMenuType === SportsMenuType.LiveSports ? selectedDetails.tournamentCategory : ''}
                        selectedLocation={selectedSportsMenuType === SportsMenuType.LiveSports ? selectedDetails.location : ''}
                        selectedSportChild={selectedSportsMenuType === SportsMenuType.LiveSports ? selectedDetails.sportChild : ''}
                        selectedTournament={selectedSportsMenuType === SportsMenuType.LiveSports ? selectedDetails.tournament : ''}
                        onSelectedDetailsChange={updateSelectedLiveSportsDetails}
                        displayShowMoreButton={false}
                        itemsLimit={999}
                        excludeTopSports={false}
                        liveStatus={DisciplineLiveStatus.LIVE}
                        supportTournamentNav={true}
                        isEsport={isEsportsPage}
                        virtualStatus={DisciplineVirtualStatus.NOT_VIRTUAL}
                        displayEarlySettlement={displayEarlySettlement}
                        enabledBetSimulate={enabledBetSimulate}
                    />
                )
            }
            {bannerMatrixConfig?.showOnLeftAboveAllSports &&
                <BannermatrixBanner
                    className="BannerWidgetLeftAboveAllSports BannerWidgetColorPack"
                    positionTag="left-above-all-sports"
                />
            }
            <SportsMenu
                controlledSelection
                sportRoute={enabledDisciplinePage ? generateSportsPageUrl : false}
                virtualSportRoute={virtualSportRoute}
                displayShortTournamentName={true}
                widgetTitle={gettext('All Sports')}
                hideTournament={true}
                hideLocation={enabledDisciplinePage ? true : false}
                selectedSport={selectedSportsMenuType === SportsMenuType.AllSports || !selectedSportsMenuType ? selectedDetails.sport : ''}
                selectedTournamentCategory={selectedSportsMenuType === SportsMenuType.AllSports || !selectedSportsMenuType ? selectedDetails.tournamentCategory : ''}
                selectedLocation={selectedSportsMenuType === SportsMenuType.AllSports || !selectedSportsMenuType ? selectedDetails.location : ''}
                selectedSportChild={selectedSportsMenuType === SportsMenuType.AllSports || !selectedSportsMenuType ? selectedDetails.sportChild : ''}
                selectedTournament={selectedSportsMenuType === SportsMenuType.AllSports || !selectedSportsMenuType ? selectedDetails.tournament : ''}
                onSelectedDetailsChange={updateSelectedAllSportsDetails}
                showMoreText={gettext('Show More')}
                showLessIcon={'minus'}
                showMoreIcon={'plus'}
                excludeTopSports={true}
                supportTournamentNav={true}
                displayShowMoreButton={false}
                itemsLimit={999}
                isEsport={isEsportsPage}
                showAllSport={true}
                enabledBetSimulate={enabledBetSimulate}
            />
            {bannerMatrixConfig?.showOnLeftUnderAllSports &&
                <BannermatrixBanner
                    className="BannerWidgetLeftAboveSearch BannerWidgetColorPack"
                    positionTag="left-under-all-sports"
                />
            }
            {helpSupportLinks && (coreHelpSupportLinks
                ? <HelpSupportLinksCore />
                : <HelpSupportLinksNDW />
            )}
            {!helpSupportLinks && settingsMenu &&
                <SettingsMenu />
            }
        </aside>
    );
}

function mapStateToProps(state: AppState): LeftSideBarStoreProps {
    return {
        deviceType: state.deviceInfo?.platform.type,
    };
}

const LeftSideBar: ComponentType = connect(mapStateToProps)(
    withRouting<LeftSideBarStoreProps>()(LeftSideBarComponent),
);

export default LeftSideBar;
